import { validateCNPJ as centralValidateCNPJ } from "../../../utils";

export function validateCNPJ(cnpj) {
    return centralValidateCNPJ(cnpj);
}


// WEBPACK FOOTER //
// ./src/components/parts/document-component/validate-cnpj.js